import { useState, useEffect } from "react";

function diff(target) {
  const ms = new Date(target).getTime() - Date.now();
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };
}

const Cell = ({ value, label }) => (
  <div className="text-center">
    <p className="font-display text-3xl sm:text-4xl tabular-nums text-ptf-primary">{String(value).padStart(2, "0")}</p>
    <p className="text-[0.58rem] uppercase tracking-[0.16em] text-ptf-text/50 mt-1">{label}</p>
  </div>
);

export default function Countdown({ targetDate, label = "Journey begins in" }) {
  const [remaining, setRemaining] = useState(() => diff(targetDate));

  useEffect(() => {
    const id = setInterval(() => setRemaining(diff(targetDate)), 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  if (!remaining) {
    return (
      <div data-testid="dawn-countdown-started" className="border border-ptf-primary/12 bg-white px-5 py-4 text-sm text-ptf-text/70">
        The journey has begun.
      </div>
    );
  }

  return (
    <div data-testid="dawn-countdown" className="border border-ptf-primary/12 bg-white px-6 py-5">
      <p className="text-[0.62rem] uppercase tracking-[0.2em] text-ptf-primary/60 mb-3">{label}</p>
      <div className="flex items-start gap-5 sm:gap-8">
        <Cell value={remaining.days} label="Days" />
        <Cell value={remaining.hours} label="Hours" />
        <Cell value={remaining.minutes} label="Mins" />
        <Cell value={remaining.seconds} label="Secs" />
      </div>
    </div>
  );
}
